<template>
  <lf-dropdown
    v-if="serviceStep"
    :value="serviceStep.service_id"
    :options="serviceOptions"
    :placeholder="t('CHECKOUT.DATA_SERVICE')"
    full-width
    :name="`${serviceStep.id}--service`"
    data-cy="step-service-dropdown"
    @change="handleServiceChange"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { storeToRefs } from "pinia";

import { checkoutBaseToDedicatedStep } from "@/helpers/checkout";
import { useCheckoutOptionsQuery } from "@/hooks/queries/options";
import { useCheckoutStore } from "@/stores/checkout";

import LfDropdown from "@/components/ui/inputs/LfDropdown.vue";

const { t } = useI18n();
const { selectedStep } = storeToRefs(useCheckoutStore());
const { data: options } = useCheckoutOptionsQuery();

const serviceStep = computed(() =>
  checkoutBaseToDedicatedStep(selectedStep.value, "service")
);

const serviceOptions = computed(
  () => options.value?.definition.available_services ?? {}
);

const handleServiceChange = (newService: string | number) => {
  if (!serviceStep.value) {
    return;
  }

  serviceStep.value.service_id = newService as string;
};
</script>
